export function pad(n: number): string {
  return String(n).padStart(2, "0");
}

/** Local calendar day as YYYY-MM-DD. */
export function todayKey(d = new Date()): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Minutes-from-midnight → HH:MM. */
export function hourLabel(min: number): string {
  return `${pad(Math.floor(min / 60))}:${pad(Math.round(min % 60))}`;
}

/** Current time as minutes from midnight. */
export function nowMinutes(d = new Date()): number {
  return d.getHours() * 60 + d.getMinutes();
}

/** Parse a YYYY-MM-DD key as a *local* date (avoids the UTC shift of new Date(str)). */
export function parseKey(key: string): Date {
  const [y, m, d] = key.split("-").map(Number);
  return new Date(y ?? 1970, (m ?? 1) - 1, d ?? 1);
}

/** Shift a YYYY-MM-DD key by n days. */
export function addDays(key: string, n: number): string {
  const d = parseKey(key);
  d.setDate(d.getDate() + n);
  return todayKey(d);
}

/** Whole-day difference key − base (positive = key is later). */
export function dayOffset(key: string, base: string): number {
  return Math.round((parseKey(key).getTime() - parseKey(base).getTime()) / 86_400_000);
}

/** "Today" / "Tomorrow" / "Yesterday" / "Planning N days ahead" / "N days ago". */
export function relDayLabel(key: string, today: string): string {
  const off = dayOffset(key, today);
  if (off === 0) return "Today";
  if (off === 1) return "Tomorrow";
  if (off === -1) return "Yesterday";
  if (off > 1) return `Planning ${off} days ahead`;
  return `${-off} days ago`;
}
